import { render, staticRenderFns } from "./WhereCanIBuySellTradeExchangeMyEthOrTokens.vue?vue&type=template&id=bc18afc0&scoped=true&"
import script from "./WhereCanIBuySellTradeExchangeMyEthOrTokens.vue?vue&type=script&lang=js&"
export * from "./WhereCanIBuySellTradeExchangeMyEthOrTokens.vue?vue&type=script&lang=js&"
import style0 from "./WhereCanIBuySellTradeExchangeMyEthOrTokens.vue?vue&type=style&index=0&id=bc18afc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc18afc0",
  null
  
)

export default component.exports